module.exports = __webpack_public_path__ + "img/businessLicense-certificate.db8ee7ab.png";